// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circular-progress {
  display: inline-block;
  position: relative;
  margin-top: 1.3%;
  width: 18%;
  /* background-color: #ec2146; */
  padding: 0px 18px 0px;
  
}

.circle-background {
  fill: none;
}

.circle-dot {
  fill: #fff;
  filter: drop-shadow(0px 0px 5px rgb(236, 33, 70));
}

.circle-progress {
  fill: none;
  stroke: #ec2146;
  stroke-width: 4px;
  stroke-linecap: round;
  transform-origin: center;
  transform: rotate(-90deg);
  animation: 5s forwards;
}

.circle-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 94%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.circle-text div {
  word-break: break-word;
}


@media(max-width:998px){
  .circular-progress{
    width: 34%;
    padding: 0px 20px 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Circular/Circular.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,+BAA+B;EAC/B,qBAAqB;;AAEvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;AACF","sourcesContent":[".circular-progress {\n  display: inline-block;\n  position: relative;\n  margin-top: 1.3%;\n  width: 18%;\n  /* background-color: #ec2146; */\n  padding: 0px 18px 0px;\n  \n}\n\n.circle-background {\n  fill: none;\n}\n\n.circle-dot {\n  fill: #fff;\n  filter: drop-shadow(0px 0px 5px rgb(236, 33, 70));\n}\n\n.circle-progress {\n  fill: none;\n  stroke: #ec2146;\n  stroke-width: 4px;\n  stroke-linecap: round;\n  transform-origin: center;\n  transform: rotate(-90deg);\n  animation: 5s forwards;\n}\n\n.circle-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  width: 94%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.circle-text div {\n  word-break: break-word;\n}\n\n\n@media(max-width:998px){\n  .circular-progress{\n    width: 34%;\n    padding: 0px 20px 0px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
